























































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { UnitExibitionData, emptyData, getInfo, postData, putData } from '@/api/heritageUnit/unitExibition'
import { getLookupByType, DDLItem } from '@/api/common/select'
import { enFirstType, enLookupType } from '@/configs/enums'
import { validateIntKey, validateFloat, validateDateRange, showVaildMsg } from '@/configs/validate'
import { getDDLItem, toDefaultInt } from '@/configs/functions'
import Element from 'element-ui'
import { UploadOptData } from '@/api/common/upload'
import { AttachInfo } from '@/api/common/attach'
import { OfficialDocData } from '@/api/officialDoc/doc'
import DocSelector from '@/components/officialDoc/select.vue'
import singleFile from '@/components/upload/singleFile.vue'
import hspGallery from '@/components/upload/gallery.vue'
import FormDialog from '@/components/dialog/formDialog.vue'
import { mergeDateRange, splitDateRange } from '@/configs/functions'
const getFormRules = (form: { [key: string]: string | any }) => {
  return {
    ExibitionName: [{ required: true, message: '请输入展示名称', trigger: 'blur' }],
    ExaminedUnit: [{ required: true, message: '请输入受检查单位名称', trigger: 'blur' }],
    // StartDate: [{ validator: validateDateRange(form, 'StartDate', 'EndDate', '开始时间不能大于结束时间'), trigger: "blur" }],
    // EndDate: [{ validator: validateDateRange(form, 'StartDate', 'EndDate', '结束时间不能小于开始时间'), trigger: "blur" }],
    FundAmount: [{ validator: validateFloat, message: '请输入数字', trigger: 'blur' }],
    TempFundAmount: [{ validator: validateFloat, message: '请输入数字', trigger: 'blur' }],
    // TempStartDate: [{ validator: validateDateRange(form, 'TempStartDate', 'TempEndDate', '开始时间不能大于结束时间'), trigger: "blur" }],
    // TempEndDate: [{ validator: validateDateRange(form, 'TempStartDate', 'TempEndDate', '结束时间不能小于开始时间'), trigger: "blur" }],
    ExibitionTypeOtherName: [{ required: true, message: '请输入其他展示方式', trigger: 'blur' }]
  }
}
@Component({
  components: { FormDialog, singleFile, hspGallery, DocSelector }
})
export default class UnitExibitionForm extends Vue {
  public name = 'UnitExibitionForm'
  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void
  public showDialog: boolean = false

  public expandNames: string[] = ['display', 'exibition', 'temp']
  public loading: boolean = false
  public form: UnitExibitionData = Object.assign({}, emptyData)
  public rules = getFormRules(this.form)
  public $refs!: {
    formData: Element.Form
  }
  public getDoc(info: { data: OfficialDocData, refTo: string }) {
    const docId = info.data.Id
    let f = this.form
    switch (info.refTo) {
      case 'Exibition':
        f.ExibitionDocId = docId
        break
      case 'TempExibition':
        f.TempExibitionDocId = docId
        break
      default:
        break
    }
  }
  get dateRange(): string[] {
    const f = this.form
    return mergeDateRange(f.StartDate, f.EndDate)
  }
  set dateRange(range: string[]) {
    const f = this.form
    const d = splitDateRange(range)
    f.StartDate = d.start
    f.EndDate = d.end
  }
  get tempDateRange(): string[] {
    const f = this.form
    return mergeDateRange(f.TempStartDate, f.TempEndDate)
  }
  set tempDateRange(range: string[]) {
    const f = this.form
    const d = splitDateRange(range)
    f.TempStartDate = d.start
    f.TempEndDate = d.end
  }
  public hasProgram: boolean = false
  public hasOutline: boolean = false
  public hasTempProgram: boolean = false
  public hasTempOutline: boolean = false
  public onFileChange(data: { opts: UploadOptData, file: AttachInfo }) {
    const opt = data.opts
    const hasFile = data.file.Id > 0
    const f = this.form
    switch (opt.refType) {
      case f.AttachTypeProgram:
        this.hasProgram = hasFile
        break
      case f.AttachTypeOutline:
        this.hasOutline = hasFile
        break
      case f.AttachTypeTempProgram:
        this.hasTempProgram = hasFile
        break
      case f.AttachTypeTempOutline:
        this.hasTempOutline = hasFile
        break
      default:
        break
    }
  }
  public hasPhoto: boolean = false
  public onGalleryChange(data: { opts: UploadOptData, files: AttachInfo[] }) {
    const list = data.files
    this.hasPhoto = list && list.length > 0
  }
  public created() {
  }
  public mounted() {
    window.eventBus.$on("openUnitExibitionForm", (info: { unitId: number, dataId: number }) => {
      this.fetchData(info)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("openUnitExibitionForm")
  }
  public open() {
    this.showDialog = true
  }
  public close() {
    this.showDialog = false
    this.$refs.formData.resetFields()
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  public fetchData(info: { unitId: number, dataId: number }) {
    this.open()
    this.loading = true
    getInfo(info.dataId).then((response: { data: any }) => {
      this.form = response.data
      this.expandNames = ['display', 'exibition', 'temp']
      this.rules = getFormRules(this.form)
      if (info.dataId === 0) {
        this.form.UnitId = info.unitId
        this.$nextTick(() => {
          if (this.$refs.formData) {
            this.$refs.formData.clearValidate()
          }
        })
      }
      this.loading = false
    }).catch((error: any) => {
      console.log(error)
    })
  }
  public sendData(data: UnitExibitionData) {
    window.eventBus.$emit("submitUnitExibitionForm", {
      data: data
    })
  }
  public onSubmit() {
    this.$refs.formData.validate((valid: boolean, obj: any) => {
      if (valid) {
        const f = Object.assign({}, this.form)
        const promist = f.Id > 0 ? putData(f.Id, f) : postData(f)
        promist.then((response: { data: any }) => {
          const data = response.data
          const msg = this.form.Id > 0 ? '保存' : '创建'
          if (data && !data.IsError) {
            this.$message({
              message: `${msg}成功`,
              type: 'success'
            })
            this.sendData(f)
            this.close()
          } else {
            this.$message({
              dangerouslyUseHTMLString: true, message: `${data.Message}`,
              type: 'warning'
            })
            console.log(response)
          }
        }, (data: any) => {
          console.log(data)
        })
      }
      else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
}
